import { render, staticRenderFns } from "./ModalDirigentes.vue?vue&type=template&id=d6569798"
import script from "./ModalDirigentes.vue?vue&type=script&lang=js"
export * from "./ModalDirigentes.vue?vue&type=script&lang=js"
import style0 from "./ModalDirigentes.vue?vue&type=style&index=0&id=d6569798&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports